"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
var OutcomeOption = /** @class */ (function (_super) {
    __extends(OutcomeOption, _super);
    function OutcomeOption(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = {
            value: state.data.outcome_option,
            error: state.error.outcome_option,
            outcome: state.data.outcome
        };
        _this._isMounted = true;
        form_store_1.default.on('STATE_CHANGE', function () {
            var state = form_store_1.default.getState();
            if (_this._isMounted) {
                _this.setState({
                    value: state.data.outcome_option,
                    error: state.error.outcome_option,
                    outcome: state.data.outcome
                });
            }
        });
        return _this;
    }
    OutcomeOption.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    OutcomeOption.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    OutcomeOption.prototype.render = function () {
        var fields = [];
        /**
         * 付属入力欄の真偽
         * 注意: state内配列の値は文字列
         */
        if (this.props.number === 7 && this.state.outcome.indexOf("7") > -1) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "input-list__child" },
                    react_1.default.createElement("label", { htmlFor: "reason", className: "input-list__title" }, "\u7406\u7531\uFF08\u4EFB\u610F\uFF09"),
                    react_1.default.createElement("input", { className: "input-text", type: "text", name: "outcome_option", defaultValue: this.state.option, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput, placeholder: "\u30D5\u30EA\u30FC\u5165\u529B" }))));
        }
        else if (this.props.number === 8 && this.state.outcome.indexOf("8") > -1) {
            // エラーメッセージの調整
            var errors_1 = form_store_1.default.getState().error, errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
            errors_1 = new Array().concat(errors_1.outcome_num1, errors_1.outcome_num2);
            errors_1.forEach(function (error, idx) {
                if (!error || errors_1 == "") {
                    errors_1.splice(idx, 1);
                }
            });
            if (errors_1.length > 0) {
                errorElem = (react_1.default.createElement("p", { className: "form-error" }, errors_1[0]));
            }
            return (react_1.default.createElement(react_1.default.Fragment, null,
                errorElem,
                react_1.default.createElement("div", { className: "input-list__child" },
                    react_1.default.createElement("div", { className: "input-set" },
                        "\uFF08",
                        react_1.default.createElement("input", { className: "input-text input-set__s", title: "\u6E1B\u80CE\u3059\u308B\u4EBA\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "number", name: "outcome_num1", onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-set__unit" }, "\u80CE\u304B\u3089"),
                        react_1.default.createElement("input", { className: "input-text input-set__s", title: "\u6E1B\u80CE\u5F8C\u306E\u4EBA\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", type: "number", name: "outcome_num2", onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-set__unit" }, "\u80CE\u306B\u6E1B\u80CE"),
                        "\uFF09"))));
        }
        else {
            return (react_1.default.createElement("div", null));
        }
    };
    return OutcomeOption;
}(react_1.Component));
exports.default = OutcomeOption;
